import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, CheckCircle2 } from "lucide-react";
import { SCHOOL, NOTIFICATIONS } from "../data/siteData";
import WhatsAppIcon from "./WhatsAppIcon";
import "./Shared.css";

/* ─── Notification Marquee Bar ─────────────────────────────── */
export const NotificationBar = () => (
  <div className="notif-bar">
    <div className="notif-bar__marquee">
      <span className="notif-bar__badge">NEW</span>
      <span>{NOTIFICATIONS.join("  |  ")}</span>
    </div>
  </div>
);

/* ─── Page Banner (inner pages) ────────────────────────────── */
export const PageBanner = ({ title, breadcrumb }) => (
  <div className="page-banner">
    <h1>{title}</h1>
    <p>Home / {breadcrumb || title}</p>
  </div>
);

/* ─── Section Title ────────────────────────────────────────── */
export const SectionTitle = ({ title, subtitle }) => (
  <div className="section-title">
    <h2>{title}</h2>
    {subtitle && <p>{subtitle}</p>}
    <div className="section-title__line" />
  </div>
);

/* ─── Contact Strip (3 cards) ──────────────────────────────── */
export const ContactStrip = () => {
  const items = [
    { Icon: Phone, label: "Call Us", value: SCHOOL.phone },
    { Icon: Mail, label: "Email Us", value: SCHOOL.email },
    {
      Icon: MapPin,
      label: "Visit Us",
      value: "Near Petrol Pump, Mahore, Reasi, J&K – 182315",
    },
  ];
  return (
    <div className="contact-strip">
      {items.map(({ Icon, label, value }) => (
        <div key={label} className="contact-strip__card card">
          <div className="contact-strip__icon">
            <Icon size={26} />
          </div>
          <h3>{label}</h3>
          <p>{value}</p>
        </div>
      ))}
    </div>
  );
};

/* ─── Enquiry Form ─────────────────────────────────────────── */
export const EnquiryForm = () => {
  const [form, setForm] = useState({
    student: "",
    parent: "",
    email: "",
    phone: "",
    grade: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (key) => (e) =>
    setForm((prev) => ({ ...prev, [key]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="enquiry-form card" style={{ textAlign: "center" }}>
        <div style={{ marginBottom: 12, color: "var(--primary)" }}>
          <CheckCircle2 size={48} />
        </div>
        <h3>Thank You!</h3>
        <p>Your enquiry has been submitted. We will contact you soon.</p>
      </div>
    );
  }

  return (
    <form className="enquiry-form card" onSubmit={handleSubmit}>
      <h3 className="enquiry-form__title">Admission Enquiry Form</h3>
      <div className="enquiry-form__grid">
        <input
          className="enquiry-form__input"
          placeholder="Student Name"
          required
          value={form.student}
          onChange={handleChange("student")}
        />
        <input
          className="enquiry-form__input"
          placeholder="Parent Name"
          required
          value={form.parent}
          onChange={handleChange("parent")}
        />
        <input
          className="enquiry-form__input"
          type="email"
          placeholder="Email Address"
          required
          value={form.email}
          onChange={handleChange("email")}
        />
        <input
          className="enquiry-form__input"
          type="tel"
          placeholder="Phone Number"
          required
          value={form.phone}
          onChange={handleChange("phone")}
        />
        <select
          className="enquiry-form__input enquiry-form__full"
          value={form.grade}
          onChange={handleChange("grade")}
          required
        >
          <option value="">Select Class for Admission</option>
          {["Nursery","LKG","UKG","1st","2nd","3rd","4th","5th","6th","7th","8th"].map(
            (g) => (
              <option key={g}>{g}</option>
            )
          )}
        </select>
        <textarea
          className="enquiry-form__input enquiry-form__full"
          placeholder="Your Message"
          rows={3}
          value={form.message}
          onChange={handleChange("message")}
        />
      </div>
      <div style={{ textAlign: "center", marginTop: 18 }}>
        <button type="submit" className="btn btn--accent">
          Submit Enquiry
        </button>
      </div>
    </form>
  );
};

/* ─── WhatsApp Floating Button ─────────────────────────────── */
export const WhatsAppFloat = () => (
  <a
    href={SCHOOL.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    className="wa-float"
    aria-label="Chat on WhatsApp"
  >
    <WhatsAppIcon size={28} color="#fff" />
  </a>
);

/* ─── Vertical Quick-Action Float ──────────────────────────── */
export const QuickActionFloat = () => (
  <div className="quick-float">
    <Link to="/admissions" className="quick-float__btn">
      Admission 2026-27
    </Link>
    <Link to="/gallery" className="quick-float__btn">
      Photo Gallery
    </Link>
  </div>
);
